import { Component, OnInit, ChangeDetectorRef, ViewChild} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { EquipmentDetails, SystemDetails } from '../../manage-equipment/models/manage-equipment.model';
import { LoadingService } from '../../../shared/services/loading.service';
import { ManageEquipmentService } from '../../manage-equipment/manage-equipment.service';
import { SetupUndercarriageService } from '../../setup-undercarriage';
import { TranslateService } from '../../../../app/translate';
import { AppService } from '../../../../app/app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, style, transition, animate, keyframes, query, stagger } from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { ThermographyInspectionService} from '../thermography-inspection.service';
import { ThermographyLinkPinVM, ThermographyInspectionDataVM, ThermographyInfoVM, ThermographynspectionVM } from '../thermography-inspection.model';
import { UserService } from '../../../../app/shared/services/user.service';
import { NotificationsService } from 'angular2-notifications';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';


@Component({
  selector: 'app-create-new-thermography-inspection',
  templateUrl: './create-new-thermography-inspection.component.html',
  styleUrls: ['./create-new-thermography-inspection.component.scss'],
  animations: [

    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':enter', stagger('500ms', [
          animate('.5s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true })
      ])
    ]),
    trigger('fadeInList', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':enter', stagger('500ms', [
          animate('.5s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-5%)', offset: 0 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true })
      ])
    ]),
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})
export class CreateNewThermographyInspectionComponent implements OnInit {

  overviewIsLoading = true;
  loadingEquipment= true;
  private _subscriptions: Subscription[] = [];
  equipmentId: number;
  inspectionId:number;
  equipmentDetails: EquipmentDetails = new EquipmentDetails();
  FamilyName:string
  
  FamilyImage_Chain: string
  FamilyImage_Frame: string
  
  userLanguage = 'english';
  public todate = new Date();


  equipmentSystems: SystemDetails[];
  leftFrameSystem :SystemDetails;
  rightFrameSystem :SystemDetails;
  rightChainSystem :SystemDetails;
  leftChainSystem :SystemDetails;

  InspectionDetails:ThermographyInspectionDataVM;

  LeftFrame:ThermographyInfoVM[];
  RightFrame:ThermographyInfoVM[];

  LeftChain:ThermographyInfoVM[];
  RightChain:ThermographyInfoVM[];

  LeftAdditional:ThermographyInfoVM[];
  RightAdditional:ThermographyInfoVM[];
  NoSideAdditional:ThermographyInfoVM[];


  SerialF_l:string;
  SerialF_r:string;
  SerialC_l:string;
  SerialC_r:string;

  smu:number;
  InspectionDate:Date;
  comment:string;
  tracksag_l:number;
  tracksag_r:number;
  chain_CMU_l:number;
  chain_CMU_r:number;
  isInspector:boolean=false;
  isInterpreter:boolean=false;

  Linkinfo:ThermographyLinkPinVM[];
  InspectionDate_:string;
  IsRelease:boolean=false;
  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private _loading: LoadingService,
    private _equipmentService: ManageEquipmentService,
    private _setupService: SetupUndercarriageService,
    private _translate: TranslateService,
    private _ref: ChangeDetectorRef,
    private _appService: AppService,
    private _sanitizer: DomSanitizer,
    private _thermographyService :ThermographyInspectionService,
    private _user: UserService,
    private _notify: NotificationsService,
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Thermography Inspection');

    
    this.equipmentId = +this.route.snapshot.paramMap.get('id');
    this.inspectionId = +this.route.snapshot.paramMap.get('id2');
    
    this._subscriptions.push(this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2)));
    this.checkUserPermission();
    this.loadEquipment();
  }
  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this._ref.detectChanges();
  }


  //Update data
  updateInspectionComment(newcomment:string){
    console.log("newcomment___", newcomment)

    this._thermographyService.UpdateThermographyComment(this.inspectionId,newcomment).subscribe(r=>{
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
     
      } else {
        this._notify.error('Failed', r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
    });

  }

  checkUserPermission() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              this.isInterpreter = true;
              break;
            case 'Interpreters': this.isInterpreter = true;
            this.isInspector = true;
            case 'Super User': this.isInterpreter = true;
            this.isInspector = true;
            case 'Administrator': this.isInterpreter = true;
            this.isInspector = true;
              this.isInterpreter = true;
              this.isInspector = true;
              break;
              case 'Customer Admin':
                this.isInterpreter = true;
                this.isInspector = true;
                  this.isInterpreter = true;
                  this.isInspector = true;
                break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );

  }

  getImage(image: string) {
    if (image != null && image !== undefined)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  loadEquipment() {
    this.loadingEquipment = true;
    this._loading.startLoading();
    this._equipmentService.getEquipmentDetails(this.equipmentId).subscribe(equipment => {
      this.equipmentDetails = equipment;
      

      console.log(this.equipmentDetails);
      this.FamilyName= this.equipmentDetails.Family;
      this.getFamilyDetails(this.FamilyName);
     
      this.LoadInspectionDetails();
      this.overviewIsLoading=false;
    });
  }



  
  

  getFamilyDetails(value: string) {
    this._setupService.getFamilyList().subscribe(res => {
      if (res != null) {
        if(Array.isArray(res))
        {
          let familydetails = res
          familydetails.map(x => {
            if (x.typedesc == value) {
              this.FamilyImage_Chain = x.ChainImage
              this.FamilyImage_Frame = x.FrameImage
            }
          })
        }
      }
    })
  }
 
  UpdateSMU(){
    var temp = new ThermographynspectionVM()
    {
      temp.InspectionDate =this.InspectionDate; //this.dateReplaced.toLocaleString();
      temp.EquipmentId =this.equipmentId;
      temp.SMU=this.smu;
    }
    this._thermographyService.ValidateSMUAndDate(temp).subscribe(result=>{
      if (result.m_Item1) {
        console.log("result11111 Righ", result)

        this._thermographyService.UpdateThermoSMU(this.inspectionId,this.smu).subscribe(r=>{
          if(r.m_Item1){
            this._notify.success('Saved',r.m_Item2);
          }else{
            this._notify.error('Failed', r.m_Item2);
          }
        });
        }
       else {
   
         this._notify.error('Failed', result.m_Item2);
       }
    }) 
  }

  UpdateInspectionDate(event:any){
    //console.log("inspectionDate__", event, this,this.InspectionDate)
    var temp = new ThermographynspectionVM()
    {
      temp.InspectionDate =this.InspectionDate; //this.dateReplaced.toLocaleString();
      temp.EquipmentId =this.equipmentId;
      temp.SMU=this.smu;
    }
    this._thermographyService.ValidateSMUAndDate(temp).subscribe(result=>{
      if (result.m_Item1) {
        console.log("result11111 Righ", result)
        this.InspectionDate_=this.getFormatedDate(new Date(this.InspectionDate));
        this._thermographyService.UpdateThermoInspectionDate(this.inspectionId,this.InspectionDate_).subscribe(r=>{
          if(r.m_Item1){
            this._notify.success('Saved',r.m_Item2);
          }else{
            this._notify.error('Failed', r.m_Item2);
          }
        });
        }
       else {
         this._notify.error('Failed', result.m_Item2);
       }
    }) 
  }



  
  CreateInspection(){

   
    }
  

    getFormatedDate = (currentDate) => {
  
      console.log("curernt ", currentDate)
      let dd = currentDate.getDate();
      let mm = currentDate.getMonth() + 1; // January is 0!
      const yyyy = currentDate.getFullYear();
      if (dd < 10) {
        dd = `0${dd}`;
      }
      if (mm < 10) {
        mm = `0${mm}`;
      }
      return `${dd} ${mm} ${yyyy}`;
    };




Loadall:boolean=false;
LoadInspectionDetails(){
  this._thermographyService.GetThermogarphyInspectionInfo(this.equipmentId, this.inspectionId).subscribe(res=>{
    this.InspectionDetails = res;
    console.log("details", this.InspectionDetails)
    this.LeftFrame = this.InspectionDetails.Frames.FrameL;
    this.RightFrame=this.InspectionDetails.Frames.FrameR;
    this.LeftChain = this.InspectionDetails.Chains.ChainL;
    this.RightChain=this.InspectionDetails.Chains.ChainR;

    this.LeftAdditional = this.InspectionDetails.AdditionalComponents.Additional_L;
    this.RightAdditional=this.InspectionDetails.AdditionalComponents.Additional_R;
    this.NoSideAdditional=this.InspectionDetails.AdditionalComponents.Additional_No;

    this.SerialC_l=this.InspectionDetails.Chains.ChainLSerial;
    this.SerialC_r=this.InspectionDetails.Chains.ChainRSerial;
    this.SerialF_l=this.InspectionDetails.Frames.FrameLSerial;
    this.SerialF_r=this.InspectionDetails.Frames.FrameRSerial;
    this.smu = this.InspectionDetails.SMU;
    this.InspectionDate = this.InspectionDetails.InspectionDate;
    this.comment=this.InspectionDetails.Comment;
    this.tracksag_l=this.InspectionDetails.trackSagL;
    this.tracksag_r=this.InspectionDetails.trackSagR;
    this.chain_CMU_l=this.InspectionDetails.Chains.CMU_Left;
    this.chain_CMU_r=this.InspectionDetails.Chains.CMU_Right;
    this.IsRelease = this.InspectionDetails.Release;

    this.loadingEquipment = false;
     console.log("InsopectionDetails__", this.InspectionDetails);
      this.Loadall=true;
      this._loading.finishedLoading();
    
  });
}

releaseReport(){
  this._thermographyService.UpdateRelease(this.inspectionId).subscribe(r=>{
    if(r.m_Item1){
      this._notify.success('Released',r.m_Item2);
      this.IsRelease= true;
    }else{
      this._notify.error('Failed', r.m_Item2);
    }
  });
}
  translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }



}
